// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/StandardCostVersion.yaml
// Generated: 2026-01-22T15:19:15.407Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateStandardCostVersion, UpdateStandardCostVersion, StandardCostVersion } from '@/types/inventory/StandardCostVersion';

/**
 * StandardCostVersion Service
 * CRUD operations for StandardCostVersion via the ABP API.
 */
export const standardCostVersionService = new EntityService<StandardCostVersion, CreateStandardCostVersion, UpdateStandardCostVersion>(
  '/api/inventory/standardcostversion',
  'StandardCostVersion',
);
